import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgLocationPin = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 24 24"
    >
        <path
            d="M6.00949 14.2467L6.00938 14.2465C5.02787 12.9536 4.49763 11.3744 4.50001 9.7511V9.75C4.50001 7.76088 5.29019 5.85322 6.69671 4.4467C8.10323 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75L19.5 9.7511C19.5024 11.3736 18.9724 12.952 17.9914 14.2443L17.9164 14.3431L17.916 14.3442L17.8762 14.3963C17.8463 14.4353 17.816 14.4746 17.7914 14.5062C17.7758 14.5265 17.7659 14.539 17.7608 14.5455C17.756 14.5515 17.7552 14.5525 17.7575 14.5498L17.7572 14.5502L12 21.3403L6.25432 14.5641C6.17188 14.459 6.09027 14.3531 6.00949 14.2467Z"
            fill="white"
            stroke="currentColor"
            strokeWidth="1.5"
        />
        <path
            d="M11.9995 12.75C11.4063 12.7499 10.8265 12.574 10.3333 12.2444C9.83994 11.9148 9.45543 11.4462 9.22836 10.8981C9.0013 10.3499 8.94189 9.74667 9.05765 9.16473C9.1734 8.58279 9.45912 8.04824 9.87868 7.62868C10.2982 7.20912 10.8328 6.9234 11.4147 6.80765C11.9967 6.69189 12.5999 6.7513 13.1481 6.97836C13.6962 7.20543 14.1648 7.58994 14.4944 8.08329C14.824 8.5765 14.9999 9.15634 15 9.74951C14.9989 10.545 14.6825 11.3075 14.12 11.87C13.5575 12.4325 12.795 12.7489 11.9995 12.75Z"
            fill="white"
            stroke="currentColor"
            strokeWidth="1.5"
        />
    </svg>
);

export const LocationPinIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgLocationPin}
        fontSize={fontSize}
    />
);
